import React from "react";
import BalanceSheetContainer from "./BalanceSheetContainer";
import BalanceSheetItem from "./BalanceSheetItem";
function BalanceSheet(props) {
  let Data = props.BalanceSheet;
  if (Data === undefined) {
    return <h3>No Balance Sheet found</h3>;
  }

  return (
    <div className="balanceSheet">
      <h1>Balance Sheet</h1>
      <div className="row">
        {Object.keys(Data).map((k) => {
          if (Data[k].isEmpty === true) {
            return (
              <div className="column" key={k}>
                {" "}
                No {k}
              </div>
            );
          }
          return (
            <div className="column" key={k}>
              <h3>{Data[k].label}</h3>
              <div>
                <table>
                  {Data[k].containers.map((c) => {
                    return (
                      <BalanceSheetContainer
                        key={c.label}
                        elements={c.elements}
                        label={c.label}
                      />
                    );
                  })}
                  {Data[k].Total === undefined ? (
                    ""
                  ) : (
                    <BalanceSheetItem
                      value={Data[k].Total}
                      label={Data[k].TotalLabel}
                    />
                  )}
                  {Data[k].Other === undefined ? (
                    ""
                  ) : (
                    <>
                      <BalanceSheetItem
                        value={Data[k].Other[0].value}
                        label={Data[k].Other[0].label}
                      />
                      <BalanceSheetItem
                        value={Data[k].Other[1].value}
                        label={Data[k].Other[1].label}
                      />
                    </>
                  )}
                </table>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BalanceSheet;
